const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FDE494"
    },
    d: "M114.759,512h61.103l-96.414-61.793L0.198,403.898C3.659,464.09,53.716,512,114.759,512z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FEA150"
    },
    d: "M335.448,476.69l-69.006-17.655H114.759c-34.072,0-61.793-27.721-61.793-61.793v-33.876 l-26.483-28.42L0,339.628v57.613c0,2.236,0.072,4.454,0.198,6.657L175.862,512h208.767L335.448,476.69z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF5D4A"
    },
    d: "M441.655,440.14c-11.244,11.637-26.993,18.894-44.414,18.894H266.442L384.629,512h12.612 c41.202,0,77.396-21.829,97.64-54.527l-27.022-16.094L441.655,440.14z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E45261"
    },
    d: "M459.034,326.014v71.228c0,16.652-6.633,31.775-17.379,42.899l53.227,17.333 C505.728,439.954,512,419.318,512,397.241v-62.805l-27.396-15.391L459.034,326.014z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF4D95"
    },
    points: "512,149.19 483.797,142.474 459.034,157.3 459.034,326.014 512,334.436 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CB319C"
    },
    d: "M512,114.759c0-57.633-42.708-105.473-98.136-113.55L344.43,30.101l-35.183,22.865h87.994 c34.072,0,61.793,27.721,61.793,61.793V157.3L512,149.19V114.759z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8A3293"
    },
    d: "M317.732,0l-65.682,24.636l-51.805,28.33h109.002L413.864,1.208C408.435,0.417,402.887,0,397.241,0 H317.732z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF5D4A"
    },
    d: "M256,406.069c18.358,0,35.954-3.32,52.226-9.38l-86.02-39.047l-91.178-18.657 C157.946,379.39,203.913,406.069,256,406.069z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E45261"
    },
    d: "M329.153,305.358c-15.883,23.465-42.748,38.918-73.153,38.918c-40.273,0-74.308-27.118-84.867-64.046 l-23.682-14.801l-40.847,4.538c2.353,25.345,11.014,48.887,24.425,69.017l177.198,57.705c38.303-14.264,69.237-43.757,85.458-81.068 l-31.753-16.085L329.153,305.358z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4D95"
    },
    d: "M167.724,256c0-21.878,8.018-41.907,21.247-57.346l-37.658-5.268l-38.25,16.892 c-4.625,14.422-7.132,29.784-7.132,45.722c0,4.712,0.244,9.365,0.671,13.966l64.53,10.262 C168.929,272.524,167.724,264.403,167.724,256z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4D95"
    },
    d: "M406.069,256c0-32.138-10.159-61.946-27.428-86.39l-37.397-5.308l-38.418,16.917 c24.873,15.631,41.45,43.298,41.45,74.781c0,18.27-5.58,35.261-15.123,49.358l64.531,10.262 C401.634,297.334,406.069,277.18,406.069,256z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CB319C"
    },
    d: "M256,167.724c17.194,0,33.242,4.959,46.826,13.495l75.815-11.609 c-27.196-38.493-72.03-63.679-122.641-63.679c-66.81,0-123.554,43.889-142.937,104.345l75.908-11.624 C205.173,179.742,229.203,167.724,256,167.724z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CB319C"
    },
    d: "M397.241,150.069c19.47,0,35.31-15.84,35.31-35.31s-15.84-35.31-35.31-35.31 c-19.47,0-35.31,15.84-35.31,35.31S377.771,150.069,397.241,150.069z"
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF5D4A"
    },
    points: "52.966,313.564 27.47,300.847 0,296.316 0,339.629 52.966,363.366 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E45261"
    },
    points: "0,253.014 0,296.316 52.966,313.564 52.966,261.437 25.446,251.543 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF4D95"
    },
    points: "52.966,219.479 25.749,219.233 0,227.59 0,253.014 52.966,261.437 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#CB319C"
    },
    points: "52.966,179.757 24.911,182.603 0,205.962 0,227.59 52.966,219.479 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#8A3293"
    },
    points: "0,205.962 52.966,179.757 52.966,119.362 21.9,122.333 0,143.241 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#523494"
    },
    d: "M205.059,0L84.206,46.481L1.387,96.928C0.477,102.741,0,108.695,0,114.759v28.482l52.966-23.878 v-4.605c0-34.072,27.721-61.793,61.793-61.793h85.487L317.732,0H205.059z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2D2D87"
    },
    d: "M114.759,0C57.545,0,9.978,42.088,1.387,96.928L205.059,0H114.759z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.882b3ae83fce1c779aacc3ab3da244f6.svg";
export { ForwardRef as ReactComponent };